import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable, catchError, tap, throwError, firstValueFrom } from 'rxjs';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class ActivesService {
  private _catalog = signal<any>(null);
  private _tickets = signal<any[]>([]);
  
  constructor(private readonly _httpClient: HttpClient) {}

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  /**
   * Getter for data
   */
    get catalog() {
    return this._catalog.asReadonly();
  }

  get tickets() {
    return this._tickets.asReadonly();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  public GetSignalsByPeriod(filter: { period: string; filter: string; page: number; page_size: number }) {
    let params = {
      period: filter.period,
      filter: filter.filter,
      page: filter.page,
      page_size: filter.page_size,
    };
    const tokenEndpoint: string = environment.api('api/signals/get_signals');

    return this._httpClient
      .get(tokenEndpoint, {
          params: params,
        })
        .pipe(
          tap((response: any) => {
            _.map(response.Data, (item: any) => {
              item.Picture = item.Image ? environment.s3Path + item.Period + '/' + item.Image : 'images/logo/tradingview.svg';
            });
          }),
        ) ;
  }

  public getCatalogActive(): Observable<any> {
    const tokenEndpoint: string = environment.api(`api/signals/GetCatalogActive`);

    return this._httpClient.get<any>(tokenEndpoint).pipe(
      tap((response: any) => {
        this._catalog.set(response.Data || []);
      }),
      catchError(this.handleError)
    );
  }

  public getFavoriteTickets(): Observable<any> {
    const tokenEndpoint: string = environment.api(`api/TradingFilter/FavoriteTickets`);

    return this._httpClient.get<any>(tokenEndpoint).pipe(
      tap((response: any) => {
        this._tickets.set(response.Data || []);
      }),
      catchError(this.handleError)
    );
  }

  public AddFavorite(ticketName: string) {
    const params = { ticketName };
    const url: string = environment.api(`api/TradingFilter/showTicket`);

    return this._httpClient.post<any>(url, params).pipe(
      tap(() => {
        this._tickets.update(tickets => [...tickets, { TicketName: ticketName }]);
    }),
      catchError(this.handleError)
    );
  }

  public DeleteFavorite(ticketName: string) {
    const params = { ticketName };
    const url: string = environment.api(`api/TradingFilter/hideTicket`);

    return this._httpClient.post<any>(url, params).pipe(
      tap(() => {
        this._tickets.update(tickets => tickets.filter(t => t.TicketName !== ticketName));
      }),
      catchError(this.handleError)
    );
  }
  private handleError(error: HttpErrorResponse) {
    return throwError(() => new Error('Algo salió mal; por favor, inténtalo de nuevo más tarde.'));
  }
}
